import {Component} from "@angular/core";

@Component({
    selector: "wbo-page-nav",
    template: "<ng-content></ng-content>",
    styleUrls: ["./page-nav.component.scss"]
})
export class PageNavComponent {
}
